import React, { useState, useEffect } from "react";
import axios from "axios";
import { Col, Row, Label } from "reactstrap";
import { UserConsumer } from "../../../UserContext";
import FilterationBar from "./FilterationBar";
import "./SpResourceLeavesInfo.scss";
import { Redirect, useParams } from "react-router-dom";
import { ResourceLeavesInfo_API } from "./ResourceLeavesInfo_API";

function SpResourceLeavesInfo() {
	let token = null;
	const { id } = useParams();
	const [supervisorsEmpList, setSupervisorsEmpList] = useState(null);
	const [selectedSupEmpList, setSelectedSupEmpList] = useState(null);
	const [isActive, setIsActive] = useState(null);
	const [resLeavesInfoData, setResLeavesInfoData] = useState({
		empID: 0,
		employeeName: "Employee Name here...",
		employeeCode: "0",
		employeeDepartment: "Employee Department here...",
		sickLeave: 0,
		compansationLeave: 0,
		annualLeave: 0,
		withoutPayLeave: 0,
		maternityLeave: 0,
		otherLeave: 0,
	});
	useEffect(() => {
		const header = { Authorization: `Bearer ${token}` };
		if (id) {
			//get resource info
			axios
				.get(
					`${ResourceLeavesInfo_API.GetResourceLeavesInfoById}/${id}`,
					{
						headers: header,
					}
				)
				.then(({ status, data }) => {
					if (status === 200) {
						setResLeavesInfoData(data);
					}
				});
		} else {
			axios
				.get(`${ResourceLeavesInfo_API.GetSupervisorsEmployeesList}`, {
					headers: header,
				})
				.then(({ status, data }) => {
					if (status === 200) {
						const supEmpList = data.map((obj) => {
							return { value: obj.employeeId, label: obj.name };
						});
						setSupervisorsEmpList(
							supEmpList.sort((a, b) =>
								a.label.localeCompare(b.label)
							)
						);
					}
				});
		}
	}, []);
	const updateTableData = (employeeId) => {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		axios
			.get(
				`${ResourceLeavesInfo_API.GetResourceLeavesInfoById}/${employeeId}`,
				{
					headers: headers,
				}
			)
			.then(({ status, data }) => {
				if (status === 200) {
					setResLeavesInfoData(data);
				}
			});
	};

	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return userDetails.designation.toString() === "4" ||
					userDetails.empRole.includes("2") ||
					userDetails.empRole.includes("5") ||
					userDetails.empRole.includes("3") ? (
					<>
						<FilterationBar
							className="my-4"
							supervisorsEmpList={supervisorsEmpList}
							selectedSupEmpList={selectedSupEmpList}
							onSupEmpChange={(value) => {
								setSelectedSupEmpList(value);
								updateTableData(value.value);
							}}
							isActive={isActive}
							onActiveChange={(value) => setIsActive(value)}
						/>
						{selectedSupEmpList && (
							<div className="formInfoContainer">
								<div className="formInfoContainerHeader">
									<Label sm={12}>Personal Information</Label>
								</div>
								<Row className="py-2 px-4">
									<Col md={12} lg={2}>
										<div className="formDetailHeader">
											<div>Employee Name</div>
										</div>
									</Col>
									<Col md={12} lg={4}>
										<p className="formValueContainer">
											{resLeavesInfoData.employeeName}
										</p>
									</Col>
									<Col md={12} lg={2}>
										<div className="formDetailHeader">
											<div>Employee Code</div>
										</div>
									</Col>
									<Col md={12} lg={4}>
										<p className="formValueContainer">
											{resLeavesInfoData.employeeCode}
										</p>
									</Col>
									<Col md={12} lg={2}>
										<div className="formDetailHeader">
											<div>Department</div>
										</div>
									</Col>
									<Col md={12} lg={4}>
										<p className="formValueContainer">
											{
												resLeavesInfoData.employeeDepartment
											}
										</p>
									</Col>
									<Col md={12} lg={2}>
										<div className="formDetailHeader">
											<div>Without Pay</div>
										</div>
									</Col>
									<Col md={12} lg={4}>
										<p className="formValueContainer">
											{resLeavesInfoData.withoutPayLeave}
										</p>
									</Col>
									<Col md={12} lg={2}>
										<div className="formDetailHeader">
											<div>Sick</div>
										</div>
									</Col>
									<Col md={12} lg={4}>
										<p className="formValueContainer">
											{resLeavesInfoData.sickLeave}
										</p>
									</Col>
									<Col md={12} lg={2}>
										<div className="formDetailHeader">
											<div>Annual</div>
										</div>
									</Col>
									<Col md={12} lg={4}>
										<p className="formValueContainer">
											{resLeavesInfoData.annualLeave}
										</p>
									</Col>
									<Col md={12} lg={2}>
										<div className="formDetailHeader">
											<div>Compensation</div>
										</div>
									</Col>
									<Col md={12} lg={4}>
										<p className="formValueContainer">
											{
												resLeavesInfoData.compansationLeave
											}
										</p>
									</Col>
									<Col md={12} lg={2}>
										<div className="formDetailHeader">
											<div>Maternity</div>
										</div>
									</Col>
									<Col md={12} lg={4}>
										<p className="formValueContainer">
											{resLeavesInfoData.maternityLeave}
										</p>
									</Col>
									<Col md={12} lg={2}>
										<div className="formDetailHeader">
											<div>Others</div>
										</div>
									</Col>
									<Col md={12} lg={4}>
										<p className="formValueContainer">
											{resLeavesInfoData.otherLeave}
										</p>
									</Col>
								</Row>
							</div>
						)}
					</>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
}

export default SpResourceLeavesInfo;
